<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div
              class="flash-message col-md-4 col-md-offset-4 text-center"
              v-if="flash"
            >
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.vehicleId)"
                  >
                    <label>Vehicle</label>
                    <select
                      v-model="trip.vehicleId"
                      name="vehicleId"
                      required
                      class="form-control"
                      v-on:change="getDeviceName"
                    >
                      <option value="" disabled>Select Vehicle</option>
                      <option
                        v-for="(item, index) in vehicle_no"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="vehicleId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Vehicle is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceId)"
                  >
                    <label>Device</label>
                    <select
                      v-model="trip.deviceId"
                      :disabled="isDeviceDisable"
                      required
                      name="deviceId"
                      class="form-control"
                    >
                      <option value="" disabled>Select Device</option>
                      <option
                        v-for="(item, index) in device_name"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="deviceId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Device is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  \
                  <label for="journeyManager" class="control-label">
                    Drivers
                  </label>
                  <vue-select
                    label="drivers"
                    multiple
                    :options="this.driver_name"
                    :searchable="true"
                    language="en-US"
                    v-model="trip.drivers"
                  >
                  </vue-select>
                </div>
                <div class="col-sm-4">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.scheduleDate)"
                  >
                    <label>Scheduled Date</label>
                    <date-picker
                      id="scheduleDate"
                      required
                      v-model="trip.scheduleDate"
                      lang="en"
                      name="scheduleDate"
                      :not-before="disabledBefore"
                      input-class="form-control"
                      width="100%"
                      use-utc="true"
                      format="DD-MM-YYYY"
                    ></date-picker>
                    <field-messages
                      name="scheduleDate"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Schedule Date is a required field
                      </div>
                      <div slot="pattern">Schedule Date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-2">
                  <label>Scheduled Time</label>
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.scheduledTime)"
                  >
                    <vue-timepicker
                      name="scheduledTime"
                      required
                      v-model="scheduledTime"
                      style="width: 271px"
                    ></vue-timepicker>
                    <field-messages
                      name="scheduledTime"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Schedule Time is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <!-- <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.locationsArray)"
                    >
                      <label>Start Location</label>
                      <select
                        v-model="trip.locationsArray"
                        required
                        name="locationsArray"
                        class="form-control"
                      >
                        <option selected disabled>Select Location</option>
                        <option
                          v-for="(item, index) in locationList"
                          :key="index"
                          :value="item"
                        >
                          {{ item.siteName }}
                        </option>
                      </select>
                      <field-messages
                        name="regionManager"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          HCV Operation Manager is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                  <button
                    class="mr-5 btn btn-default"
                    type="button"
                    @click="addField(input, phoneNumbers)"
                  >
                    add new location
                  </button>
                  <button
                    class="mr-5 btn btn-default"
                    type="button"
                    v-show="phoneNumbers.length > 1"
                    @click="removeField(index, phoneNumbers)"
                  >
                    add new location
                  </button> -->

                  <div
                    v-for="(input, index) in locations"
                    :key="index"
                    class="input wrapper flex items-center"
                  >
               
                    <!-- <input
            type="text"
            v-model="input.phone"
            class="h-10 rounded-lg outline-none p-2"
            placeholder=" Enter Phone Number"
          /> -->
                    <validate auto-label class="form-group required-field">
                      <label>Stop {{index+1}}</label>
                      <select
                        v-model="input.locationId"
                        required
                        name="locationsArray"
                        class="form-control"
                        @change="handleChange($event, index)"
                      >
                        <option selected disabled>Select Location</option>
                        <option
                          v-for="(item, index) in locationList"
                          :key="index"
                          :value="item._id"
                        >
                          {{ item.siteName }}
                        </option>
                      </select>
                      <field-messages
                        name="regionManager"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          HCV Operation Manager is a required field
                        </div>
                      </field-messages>
                    </validate>
                    <!--          Add Svg Icon-->
                       <svg
                     v-show="index === (locations.length) -1"
                      @click="addField(input, locations)"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="ml-2 cursor-pointer"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        fill="green"
                        d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
                      />
                    </svg>

                    <!--          Remove Svg Icon-->
                    <svg
                      v-show="locations.length > 2"
                      @click="removeField(index, locations)"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      class="ml-2 cursor-pointer"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        fill="#EC4899"
                        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
                      />
                    </svg>
                  </div>
                </div>

            

                <div class="col-sm-3">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.regionManager)"
                  >
                    <label>HCV Operation Manager</label>
                    <select
                      v-model="trip.regionManager"
                      :disabled="isGAHeadDisable"
                      required
                      name="regionManager"
                      class="form-control"
                    >
                      <option selected disabled
                        >Select HCV Operation Manager</option
                      >
                      <option
                        v-for="(item, index) in region_managers"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="regionManager"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        HCV Operation Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-3">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.journeyManager)"
                  >
                    <label>Journey Manager</label>
                    <select
                      v-model="trip.journeyManager"
                      :disabled="isJourenyManagerDisable"
                      required
                      name="journeyManager"
                      class="form-control"
                    >
                      <option value="" disabled>Select Jouney Manager</option>
                      <option
                        v-for="(item, index) in journey_managers"
                        :key="index"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages
                      name="journeyManager"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Journey Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Trip' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createTrip"
                :disabled="!formstate.$valid"
              >
                Add Trip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formService, eventBus, tripService } from '../../../services';
import { EVENTS } from '../../../config';
import Config, { USER_ROLES } from '../../../config';
import { mapState } from 'vuex';
import 'vue2-timepicker/dist/VueTimepicker.css';
import axios from 'axios';

export default {
  name: 'TripCreate',
  data() {
    return {
      loading: false,
      disabledBefore: new Date(),
      isDeviceDisable: false,
      isJourenyManagerDisable: false,
      isGAHeadDisable: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      region_list: {},
      region_managers: {},
      start_site: {},
      end_site: {},
      vehicle_no: {},
      route_list: {},
      driver_name: [],
      device_name: {},
      journey_managers: {},
      scheduledTime: '',
      projectFormat: 'hh:mm',
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      device: {
        status: 'active',
      },
      trip: {
        vehicleId: '',
        deviceId: '',
        journeyManager: '',
        regionManager: '',
        driverId: '',
        subTrips:[]
      },
      driver: [],
      locationList: [],
      locations: [{ locationId: '' },
      { locationId: '' }],
      list: [],
    };
  },
  mounted: function() {
    //this.getRegionList()
    this.getRegionManager();
    this.getDriverName();
    // this.getDeviceName()
    this.getRouteName();
    this.getVehicle();
    this.getJourneyManager();
    this.getLocations();
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    createTrip() {
      this.loading = true;
      this.driver = this.trip.drivers.map(el => {
        return el.value;
      });

      //   console.log('tt', driver , this.trip);
      this.trip = {
        driverId: this.driver,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.trip.deviceId,
        journeyManager: this.trip.journeyManager,
        regionManager: this.trip.regionManager,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId,
        subTrips: this.list
      };
      console.log("llllist",this.list)
      return tripService
        .tripGroupAdd(this.trip)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Trip added!', 'Success!');
          this.$router.push('/trip');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('trip Add failed! Try Again', 'Error!');
          if (error.data.message == 'dvgdxfv') {
            this.$snotify.success('Trip added!', 'Success!');
            this.$router.push('/trip');
          }
        });
    },

    getRegionManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = `["${this.user._id}"]`;
        this.isGAHeadDisable = true;
        this.$regionDataRepository.list(params).then(res => {
          this.loading = false;
          if (res.data.docs) {
            regionManagerList = res.data.docs.map(item => {
              this.trip.regionManager = item.regionManager;
              return {
                key: item.regionManager,
                value:
                  item.regionManagerFirstName +
                  ' ' +
                  item.regionManagerLastName,
              };
            });
          }
          this.region_managers = regionManagerList;
        });
      } else {
        params.roleRank = 2;
        this.$userRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              regionManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.firstName + ' ' + item.lastName,
                };
              });
            }
            this.region_managers = regionManagerList;
          })
          .catch(error => {
            this.loading = false;
            console.error('Region Manager.requestFunction-error:', error);
            this.$snotify.error('Get region manager list failed', 'Error!');
          });
      }
    },
    getJourneyManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 3;
      let journeyManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params._id = `["${this.user._id}"]`;
        this.isJourenyManagerDisable = true;
        this.trip.journeyManager = this.user._id;
      }
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            journeyManagerList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.journey_managers = journeyManagerList;
        })
        .catch(error => {
          this.loading = false;
          console.error('journey Manager.requestFunction-error:', error);
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute(
        'sourceSite',
      );
      this.destinationSite = e.target.options[
        e.target.selectedIndex
      ].getAttribute('destinationSite');
    },
    getVehicle() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      let vehicleList = [];
      this.$vehicleDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            vehicleList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.regNo,
                deviceId: item.deviceId,
              };
            });
          }
          this.vehicle_no = vehicleList;
        })
        .catch(error => {
          this.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          this.$snotify.error('Get vehicle list failed', 'Error!');
        });
    },
    getDriverName() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      this.$driverDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.driver_name = res.data.docs.map(item => {
              return {
                value: item._id,
                drivers: item.driverName,
              };
            });
          }
          console.log('driverlist', this.driver_name);
        })
        .catch(error => {
          this.loading = false;
          console.error('driver.requestFunction-error:', error);
          this.$snotify.error('Get driver list failed', 'Error!');
        });

      // }
    },
    getDeviceName(e) {
      const params = {};
      const [device] = this.vehicle_no.filter(ele => ele.key == e.target.value);
      // this.trip.vehicleId = device.key;
      this.loading = true;
      params.$limit = 0;
      if (device.deviceId) {
        params._id = device.deviceId;
        this.isDeviceDisable = true;
      }
      this.trip.deviceId = device.deviceId;
      //params.roleRank = 4;
      let deviceList = [];
      this.$deviceDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            deviceList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.deviceId,
              };
            });
          }
          this.device_name = deviceList;
        })
        .catch(error => {
          this.loading = false;
          console.error('device.requestFunction-error:', error);
          this.$snotify.error('Get device list failed', 'Error!');
        });
    },
    getRouteName() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let routeList = [];
      params.$select = ['name', '_id', 'startSite', 'endSite'];
      this.$triprouteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            routeList = res.data.docs;
          }
          this.route_list = routeList;
        })
        .catch(error => {
          this.loading = false;
          console.error('triproute.requestFunction-error:', error);
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },

    /*get locations */
    getLocations() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName'];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.locationList = res.data.docs;
        })
        .catch(error => {
          this.loading = false;
          console.error('triproute.requestFunction-error:', error);
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },

    /*add new location */
    addField(value, fieldType) {
      console.log('value', value, fieldType);
      fieldType.push({ value: '' });
      console.log("ll",this.locations)
    },

    /*remove location */
    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },

    /*handle change of stops */
    handleChange(event, index) {
      const locations = this.locations;
      if (index > 0) {
        this.checkRoute(index);
      }
      // console.log("event",event.target.value,i)
    },

    /*check if route exists between two locations or not */
    checkRoute(index) {
      //pick the selected location from index and index-1 and then find route
      const route = this.route_list.find(
        el =>
          this.locations[index - 1].locationId === el.startSite &&
          this.locations[index].locationId === el.endSite,
      );
      let val = {
        routeId: route._id,
        startSite: route.startSite,
        endSite: route.endSite,
      };
      this.list.push(val);

      //   console.log(test.push[{routeId: route._id ,
      //   startSite: route.startSite,
      //   endSite: route.endSite}] )

      //   this.list[...this.list ,{routeId: route._id ,
      //   startSite: route.startSite,
      //   endSite: route.endSite}]
    },

    fieldClassName: function(field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>
<style scoped>
.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}
.has-danger {
  color: red;
}
.mt {
  margin-top: 7px;
}
.gradientbt {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
  color: white;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>



// WEBPACK FOOTER //
// TripCreate.vue?356590b3